import React from "react";

import Typography from "@material-ui/core/Typography";
import NullChip from "../chips/NullChip";

export default function KeyValueText({ keyName, value, color }) {
  return (
    <div style={{ display: "block" }}>
      <Typography variant="caption" color="textSecondary" gutterBottom>
        {`${keyName} : `}
      </Typography>
      {!!value ? (
        <Typography
          variant="body2"
          color={!!color ? color : "textSecondary"}
          component="span"
        >
          {value}
        </Typography>
      ) : (
        <NullChip />
      )}
    </div>
  );
}
